export default __webpack_public_path__ + "static/media/vip-6.d584ae45.gif";